import { useMemo } from "react";
import { ResourceCategory, RESOURCES_LIMIT, ResourcesFetchParams } from "modules/Catalog/hooks/useFetchParams";
import { SortOrder } from "../components/Sort/types";
import { useFetchParams } from "./useFetchParams";

type InputResource = ResourcesFetchParams & {
  orderByFields: string[];
  limit: number;
  geometryFilter?: string;
};

export const useInputResource = (): Nullable<InputResource> => {
  const params = useFetchParams();
  const orderByFields = useMemo(
    () =>
      Object.entries(params.sort)
        .map(([sortType, sortOrder]) =>
          sortOrder === SortOrder.ASC ? sortType : sortOrder === SortOrder.DES ? `-${sortType}` : void 0,
        )
        .filter(Boolean),
    [params.sort],
  );

  return useMemo(
    () =>
      params
        ? {
            ...params,
            filter: params.filter ? `@${params.filter}` : "",
            orderByFields,
            geometryFilter: params.geometryFilter,
            limit: params.limit || RESOURCES_LIMIT,
            offset: params.offset || 0,
            types: params.types,
            group:
              params.category === ResourceCategory.User
                ? "my"
                : params.category === ResourceCategory.Shared
                ? "role"
                : "public",
          }
        : void 0,
    [params, orderByFields],
  );
};
